import { TemplatePageType } from "models";

export const getPageName = (pageType: TemplatePageType) => {
  switch (pageType) {
    case TemplatePageType.coverPage:
      return "Cover Page";
    case TemplatePageType.contentsPage:
      return "Contents";
    case TemplatePageType.defectList:
      return "Defect List";
    case TemplatePageType.customPage:
      return "Custom Section";
  }
};

/**
 * Subtitle shown under the fixed (data-driven) sections to explain why they
 * can't be moved or deleted. Custom sections return undefined.
 */
export const getPageSubtitle = (pageType: TemplatePageType): string | undefined => {
  switch (pageType) {
    case TemplatePageType.coverPage:
      return "Design";
    case TemplatePageType.contentsPage:
      return "Auto-generated";
    case TemplatePageType.defectList:
      return "From your defect lists";
    default:
      return undefined;
  }
};
